import { Select } from '@driftt/tide-core-legacy'

import './style.styl'

const PlaybookInboxSelect = ({ onSelectChange, selectedInboxId, inboxOptions, isLoading }) => {
  return (
    <div className="playbook-inbox-select">
      <div className="playbook-inbox-select-title">Target inbox</div>
      <div className="playbook-inbox-select-description">
        We will direct conversations created by this playbook to the selected inbox.
      </div>
      <Select
        className="playbook-inbox-select-box"
        options={inboxOptions}
        value={selectedInboxId}
        onChange={onSelectChange}
        isLoading={isLoading}
      />
    </div>
  )
}

export default PlaybookInboxSelect



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/PlaybookInboxSelect/component.js